<div
  [ngClass]="{
    tl: alignment === layoutEnum.left,
    tr: alignment === layoutEnum.right,
    tc: alignment === layoutEnum.center
  }"
>
  <ng-container
    *ngFor="let button of buttons; let first = first; let last = last"
  >
    <a
      class="mb2 mt2"
      [jbSitemapLinker]="button?.href"
      jbButton
      [theme]="
        button.ctaButtonColor === 'standard'
          ? 'standard'
          : button.theme === 'light'
          ? 'ctaPrimary'
          : 'ctaSecondary'
      "
      [target]="button.newWindow"
      [ngClass]="{
        mr2: buttons.length > 1 && !(windowService.isMobile | async) && !last,
        ml2: buttons.length > 1 && !(windowService.isMobile | async) && !first
      }"
      >{{ button.title }}</a
    >
  </ng-container>
</div>
